import { KeyboardEvent, memo, ReactElement, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Input } from "components/Input/Input";
import * as THREE from "three";
import { Group, Mesh, MeshPhysicalMaterial, Object3D } from "three";
// import { Actions } from "components/Actions/Actions";
// import { ActionsType } from "types";
// import { useLangContext } from "components/Lang/Lang";
import { rgbToHex } from "utils/color/rgbToHex";
import { hexToRGB } from "utils/HexToRGB";
// import { Form } from "components/Form/Form";
import { useLangContext } from "context/Lang";
import { Actions } from "components/Actions";
// import { useEditorContext } from "../EditorProvider";


interface PropertiesProps extends ActionsType {
    selectObject3DRef: { current: Object3D | null }
    PivotRef: { current: Group | null }
}


export const Properties = memo(({ selectObject3DRef = { current: null }, PivotRef = { current: null }, ...props }: PropertiesProps): ReactElement => {



    const baseObject = useRef<Object3D | null>(null);
    const { gW } = useLangContext();




    useEffect(() => {
        if (selectObject3DRef.current) {
            baseObject.current = selectObject3DRef.current.clone();
            (baseObject.current as Mesh).userData = { ...(baseObject.current as Mesh).userData, color: rgbToHex(((baseObject.current as Mesh).material as MeshPhysicalMaterial)?.color||"#eee") }
        }
    }, []);

    const onKeyDown = (e: any) => {


        if ((e as KeyboardEvent).key === "Enter") {

        }
    }

    useEffect(() => {

        document.removeEventListener("keydown", onKeyDown)
        document.addEventListener("keydown", onKeyDown)

        return () => {
            document.removeEventListener("keydown", onKeyDown)
        }
    }, []);




    return <div
        className={" w-full flex flex-col h-[100%]   justify-center items-center p-2      top-0 left-0 "}
    >


        <div className='w-full text-center h-[95%] py-2 overflow-y-auto px-2'>
            {/* قسم المقياس - Scale */}
            <div className=" grid text-primary-700 grid-cols-4 " >
                <div className="  " ></div>
                <div className="  " >X</div>
                <div className="  " >Y</div>
                <div className="  "  >Z</div>

            </div>



            <div className="grid items-center text-primary-700   grid-cols-4 gap-1 ">
                <p>{gW("scale")}</p>
                <Input
                    className=" p-1  "
                    name="scaleX"
                    // label={`${gW("scale")} - X`}
                    defaultValue={selectObject3DRef.current?.scale?.x + ""}
                    type="number"
                    onChange={(e) => {
                        if (selectObject3DRef.current?.scale) {
                            selectObject3DRef.current.scale.x = Number(e.target.value);
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
                <Input
                    name="scaleY"
                    className=" p-1  "
                    // label={`${gW("scale")} - Y`}
                    defaultValue={selectObject3DRef.current?.scale?.y + ""}
                    type="number"
                    onChange={(e) => {
                        if (selectObject3DRef.current?.scale) {
                            selectObject3DRef.current.scale.y = Number(e.target.value);
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
                <Input
                    name="scaleZ"
                    className=" p-1  "

                    // label={`${gW("scale")} - Z`}
                    defaultValue={selectObject3DRef.current?.scale?.z + ""}
                    type="number"
                    onChange={(e) => {
                        if (selectObject3DRef.current?.scale) {
                            selectObject3DRef.current.scale.z = Number(e.target.value);
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
            </div>

            {/* قسم الموقع - Position */}
            <div className="grid text-primary-700 items-center grid-cols-4 gap-1 ">
                <p>{gW("position")}</p>
                <Input
                    name="positionX"
                    className=" p-1  "
                    defaultValue={selectObject3DRef.current?.position?.x + ""}
                    type="number"
                    onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (selectObject3DRef.current?.position) {
                            selectObject3DRef.current.position.x = value;
                            if (PivotRef.current) PivotRef.current.position.x = value;
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
                <Input
                    name="positionY"
                    className=" p-1  "
                    defaultValue={selectObject3DRef.current?.position?.y + ""}
                    type="number"
                    onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (selectObject3DRef.current?.position) {
                            selectObject3DRef.current.position.y = value;
                            if (PivotRef.current) PivotRef.current.position.y = value;
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
                <Input
                    name="positionZ"
                    className=" p-1  "
                    defaultValue={selectObject3DRef.current?.position?.z + ""}
                    type="number"
                    onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (selectObject3DRef.current?.position) {
                            selectObject3DRef.current.position.z = value;
                            if (PivotRef.current) PivotRef.current.position.z = value;
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
            </div>

            {/* قسم الدوران - Rotation */}
            <div className="grid  items-center text-primary-700  grid-cols-4 gap-1 mb-2">
                <p> {gW("rotation")} </p>
                <Input
                    name="rotationX"
                    // label={`${gW("rotation")} - X`}
                    defaultValue={selectObject3DRef.current?.rotation?.x + ""}
                    type='range'
                    max={Math.PI * 2}
                    min={0}
                    step={0.01}
                    onChange={(e) => {
                        if (selectObject3DRef.current?.rotation) {
                            selectObject3DRef.current.rotation.x = Number(e.target.value);
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
                <Input
                    name="rotationY"
                    // label={`${gW("rotation")} - Y`}
                    defaultValue={selectObject3DRef.current?.rotation?.y + ""}
                    type='range'
                    max={Math.PI * 2}
                    min={0}
                    step={0.01}
                    onChange={(e) => {
                        if (selectObject3DRef.current?.rotation) {
                            selectObject3DRef.current.rotation.y = Number(e.target.value);
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
                <Input
                    name="rotationZ"
                    // label={`${gW("rotation")} - Z`}
                    defaultValue={selectObject3DRef.current?.rotation?.z + ""}
                    type='range'
                    max={Math.PI * 2}
                    min={0}
                    step={0.01}
                    onChange={(e) => {
                        if (selectObject3DRef.current?.rotation) {
                            selectObject3DRef.current.rotation.z = Number(e.target.value);
                            selectObject3DRef.current.userData.isUpdate = true;
                        }
                    }}
                />
            </div>

            {/* الألوان والشفافية */}
            <Input
                name="color"
                type="color"
                label={gW("color")}
                defaultValue={rgbToHex(((selectObject3DRef.current as Mesh).material as MeshPhysicalMaterial)?.color||"#eee")}
                onChange={(e) => {
                    if (!selectObject3DRef.current) return;

                    const mesh = selectObject3DRef.current as Mesh;
                    let material = mesh.material as MeshPhysicalMaterial;
                    const rgb = hexToRGB(`${e.target.value}`);
                    mesh.material = material.clone();
                    material = mesh.material as MeshPhysicalMaterial;
                    material.color.set(rgb[0], rgb[1], rgb[2]);
                    material.needsUpdate = true;                    
                    mesh.userData.isUpdate = true;
                }}
            />

            <Input
                name="opacity"
                type="range"
                label={gW("opacity")}
                max={1}
                defaultValue={((selectObject3DRef.current as Mesh).material as MeshPhysicalMaterial)?.opacity||1 }
                min={0}
                step={0.01}
                onChange={(e) => {
                    const material = (selectObject3DRef.current as Mesh).material as MeshPhysicalMaterial;
                    material.opacity = parseFloat(e.target.value);
                    if (selectObject3DRef.current) selectObject3DRef.current.userData.isUpdate = true;
                }}
            />

            {/* معلمات الهندسة الديناميكية - Geometry Parameters */}
            <div className="grid  gap-1 mt-2 border-t border-primary/10 pt-2">
                {Object.entries(((selectObject3DRef.current as Mesh)?.geometry as any)?.parameters || {}).map((entry, index) => (
                    <Input
                        disabled={entry[1] === true || entry[1] === false}
                        key={index}
                        name={entry[0]}
                        label={gW(entry[0])}
                        defaultValue={(entry[0].split("Segments")?.length > 1 ? entry[1] : Number(entry[1]).toFixed(2)) + ""}
                        type={"range"}
                        max={((entry[0].split("theta")?.length > 1 && entry[0].split("Segments")?.length === 1) || entry[0].split("phi")?.length > 1 || entry[0] === "arc") ? 6.28 : entry[0] === "detail" ? 5 : 50}
                        min={entry[0].toLowerCase().split("segments")?.length > 1 ? 2 : 0}
                        step={entry[0].toLowerCase().split("segments")?.length > 1 ? 1 : entry[0] === "detail" ? 1 : 0.01}
                        onChange={(e) => {
                            const newValue = parseFloat(e.target.value || "0.00");
                            const selectedMesh = selectObject3DRef.current as Mesh;
                            if (!selectedMesh || !selectedMesh.geometry) return;

                            const geometry = selectedMesh.geometry;
                            const geometryType = geometry.type;
                            let params = { ...(geometry as any).parameters, [entry[0]]: newValue };

                            let newGeometry;
                            switch (geometryType) {
                                case "BoxGeometry":
                                    newGeometry = new THREE.BoxGeometry(
                                        params.width, params.height, params.depth
                                    );
                                    break;
                                case "ConeGeometry":
                                    newGeometry = new THREE.ConeGeometry(
                                        params.radius, params.height, params.radialSegments
                                    );
                                    break;
                                case "CylinderGeometry":
                                    newGeometry = new THREE.CylinderGeometry(
                                        params.radiusTop, params.radiusBottom, params.height,
                                        params.radialSegments, params.heightSegments,
                                        params.openEnded, params.thetaStart, params.thetaLength
                                    );
                                    break;
                                case "SphereGeometry":
                                    newGeometry = new THREE.SphereGeometry(
                                        params.radius,
                                        params.widthSegments,
                                        params.heightSegments,
                                        params.phiStart,
                                        params.phiLength,
                                        params.thetaStart,
                                        params.thetaLength
                                    );
                                    break;
                                case "PlaneGeometry":
                                    newGeometry = new THREE.PlaneGeometry(
                                        params.width, params.height, params.widthSegments, params.heightSegments
                                    );
                                    break;
                                case "TorusGeometry":
                                    newGeometry = new THREE.TorusGeometry(
                                        params.radius, params.tube, params.radialSegments, params.tubularSegments, params.arc
                                    );
                                    break;
                                case "TorusKnotGeometry":
                                    newGeometry = new THREE.TorusKnotGeometry(
                                        params.radius, params.tube, params.radialSegments, params.tubularSegments, params.p, params.q
                                    );
                                    break;
                                case "CircleGeometry":
                                    newGeometry = new THREE.CircleGeometry(
                                        params.radius, params.segments, params.thetaStart, params.thetaLength
                                    );
                                    break;
                                case "RingGeometry":
                                    newGeometry = new THREE.RingGeometry(
                                        params.innerRadius, params.outerRadius, params.thetaSegments, params.phiSegments
                                    );
                                    break;
                                case "IcosahedronGeometry":
                                    newGeometry = new THREE.IcosahedronGeometry(
                                        params.radius, params.detail
                                    );
                                    break;
                                default:
                                    console.warn(`Unsupported geometry type: ${geometryType}`);
                                    return;
                            }

                            if (newGeometry) {
                                selectedMesh.geometry.dispose();
                                selectedMesh.geometry = newGeometry;
                                selectedMesh.userData.isUpdate = true;
                            }
                        }}
                    />
                ))}
            </div>
        </div>




        <div className=" flex flex-col items-center  ">
            <Actions
                animateType={{ animate: false }}
                actions={["delete", "save", "cancel", "copy"]}
                {...props}

                onCancel={() => {

                    if (selectObject3DRef.current) {
                        selectObject3DRef.current.position.set(baseObject.current?.position.x || 0, baseObject.current?.position.y || 0, baseObject.current?.position.z || 0)
                        selectObject3DRef.current.scale.set(baseObject.current?.scale.x || 0, baseObject.current?.scale.y || 0, baseObject.current?.scale.z || 0)
                        selectObject3DRef.current.rotation.set(baseObject.current?.rotation.x || 0, baseObject.current?.rotation.y || 0, baseObject.current?.rotation.z || 0)
                        selectObject3DRef.current.userData.isUpdate = false;
                        ((selectObject3DRef.current as Mesh).material as MeshPhysicalMaterial).color.set(...hexToRGB((baseObject.current as Mesh).userData.color))
                    }
                    props.onCancel?.()

                }}


                onDelete={() => {

                    if (selectObject3DRef.current) {
                        selectObject3DRef.current.userData.isDelete = true;
                    }

                    props.onDelete?.();
                }}
                onCopy={() => {
                    
                    props.onCopy?.(selectObject3DRef.current)
                
                }}

                onSave={props.onSave}
            />
        </div>


    </div>
})